import { render, staticRenderFns } from "./EntityDownload.vue?vue&type=template&id=70ca7c1b&scoped=true&"
import script from "./EntityDownload.vue?vue&type=script&lang=js&"
export * from "./EntityDownload.vue?vue&type=script&lang=js&"
import style0 from "./EntityDownload.vue?vue&type=style&index=0&id=70ca7c1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca7c1b",
  null
  
)

export default component.exports